import React from 'react';
import FundingLifecycleWorkspace from '../components/FundingLifecycleWorkspace';

export default function GrantsPage() {
  return <FundingLifecycleWorkspace kind="grant" />;
}
